export const SEARCH_LABEL = 'Keyword Search'
